const getters = {
    getPermintaanKasOutletList: (state) => state.permintaanKasOutletList,
    getPermintaanKasOutletDetail: (state) => state.permintaanKasOutletDetail,
    getPagination: (state) => state.pagination,
    getSearch: (state) => state.search,
    getIsSearch: (state) => state.isSearch,
    getQueryPermintaanOutletList: (state) => state.queryPermintaanOutletList,
    getScrollPosition: (state) => state.scrollPosition,
};

export default getters;
